import { generateClient } from 'aws-amplify/api';

// One AppSync client for the whole app. Auth comes from the Cognito session
// configured in config/appConfig.js.
let client;
const getClient = () => (client = client || generateClient());

// Run a GraphQL operation and return data[field]. Throws an Error whose message
// is the first GraphQL error, so callers can show it inline.
export async function gql(query, variables, field) {
    try {
        const res = await getClient().graphql({ query, variables });
        return res.data[field];
    } catch (e) {
        const message = e?.errors?.[0]?.message || e?.message || 'Request failed';
        const err = new Error(message);
        err.unauthorized = /unauthori[sz]ed|not authori[sz]ed|access denied/i.test(message);
        throw err;
    }
}
